export default function (...args)
{
	return {

		events: ['click'],

		getValue(default_value = 0, _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		isEmpty(value = this.getValue())
		{
			return value == 0;
		},

		handleEvents(ev)
		{
			this.setValue(this.getValue() ^ 1);
			this.refresh();
		}

	};
}

